import { create } from 'zustand';
import { FinanceItem, FinanceSearchParams, FinanceSummary } from './types';

interface FinanceStore {
  dataSource: FinanceItem[];
  summary: FinanceSummary | null;
  searchParams: FinanceSearchParams;
  pagination: { page_index: number; page_size: number; total: number };
  accountCountryValue: [number, string] | undefined;
  initialized: boolean;

  setDataSource: (data: FinanceItem[]) => void;
  setSummary: (summary: FinanceSummary | null) => void;
  setSearchParams: (params: Partial<FinanceSearchParams>) => void;
  setPagination: (pagination: Partial<{ page_index: number; page_size: number; total: number }>) => void;
  setAccountCountryValue: (value: [number, string] | undefined) => void;
  setInitialized: (v: boolean) => void;
  reset: () => void;
}

const useFinanceStore = create<FinanceStore>((set) => ({
  dataSource: [],
  summary: null,
  searchParams: {
    cid: undefined,
    country: undefined,
    start_date: '',
    end_date: '',
    sku: '',
  },
  pagination: { page_index: 1, page_size: 20, total: 0 },
  accountCountryValue: undefined,
  initialized: false,

  setDataSource: (data) => set({ dataSource: data }),
  setSummary: (summary) => set({ summary }),
  setSearchParams: (params) =>
    set((state) => ({ searchParams: { ...state.searchParams, ...params } })),
  setPagination: (pagination) =>
    set((state) => ({ pagination: { ...state.pagination, ...pagination } })),
  setAccountCountryValue: (value) => set({ accountCountryValue: value }),
  setInitialized: (v) => set({ initialized: v }),
  reset: () =>
    set({
      dataSource: [],
      summary: null,
      searchParams: { cid: undefined, country: undefined, start_date: '', end_date: '', sku: '' },
      pagination: { page_index: 1, page_size: 20, total: 0 },
      accountCountryValue: undefined,
      initialized: false,
    }),
}));

export default useFinanceStore;
